var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/core-js/object/values", "get-closest"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/core-js/object/values"), require("get-closest"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keys, global.values, global.getClosest);
    global.breakpoints = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _keys, _values, _getClosest) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.getCurrentBreakpoint = _exports.nextBreakpoints = _exports.default = void 0;
  _keys = _interopRequireDefault(_keys);
  _values = _interopRequireDefault(_values);
  _getClosest = _interopRequireDefault(_getClosest);
  // "Old" Replay
  var _default = {
    SMALL: 0,
    MEDIUM: 640,
    LARGE: 1024,
    XLARGE: 1200,
    XXLARGE: 1440
  }; // Next

  _exports.default = _default;
  var nextBreakpoints = {
    XSMALL: 0,
    SMALL: 420,
    MEDIUM: 768,
    LARGE: 1024,
    XLARGE: 1200,
    XXLARGE: 1440
  };
  _exports.nextBreakpoints = nextBreakpoints;

  var getCurrentBreakpoint = function getCurrentBreakpoint(defaultBreakpointFromArg) {
    var defaultBreakpoint = defaultBreakpointFromArg || nextBreakpoints.XLARGE;
    var values = (0, _values.default)(nextBreakpoints);

    var index = _getClosest.default.lowerNumber(global.innerWidth || defaultBreakpoint, values);

    return (0, _keys.default)(nextBreakpoints)[index].toLowerCase();
  };

  _exports.getCurrentBreakpoint = getCurrentBreakpoint;
});